import { Button, Container } from "@mui/material";
import { Typography, Box, BreadcrumbList, Paragraph } from "@okta/odyssey-react-mui";
import EventsTable from "../components/tables/EventsTable";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { HomeIcon } from "@okta/odyssey-react-mui/icons";
import { useFlags } from "flagsmith/react";

const Events = () => {
    const flags = useFlags(['event_create']);
    const navigate = useNavigate();

    return (
        <>
            <Container className='AppContent'>
                <div className="appComponent">
                    <BreadcrumbList>
                        <RouterLink to='/'><HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" /></RouterLink>
                        <Paragraph href="">Event Management</Paragraph>
                    </BreadcrumbList>
                    <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2.285rem'}}>
                        <Typography variant="h1">
                            Manage Events
                            <Typography variant="support">Hands-on labs are an excellent way for prospects and customers to learn about and evaluate Okta's products.</Typography>
                        </Typography>
                        {flags.event_create.enabled && 
                            <Box sx={{ justifyContent: 'flex-end', display:'flex' }}>
                                <Button onClick={()=> navigate('/events/create')}>Create Event</Button>
                            </Box>
                        }
                    </Box>
                    <EventsTable/>
                </div>
            </Container>
        </>
    )
}

export default Events;